import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { UploadContext } from "@air/component-upload-dropzone";
import { Button } from "@air/primitive-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import Image from "next/legacy/image";
import { memo, useCallback, useContext } from "react";
import { BOARD_COLLECTION_EMPTY_STATE, BOARD_COLLECTION_SELECT_FILES, EMPTY_BOARD_IMG_ALT } from "~/constants/testIDs";
export const BoardCollectionEmptyState = /*#__PURE__*/ memo(()=>{
    const { openUploader } = useContext(UploadContext);
    const { isAboveSmallScreen } = useBreakpointsContext();
    const _openUploader = useCallback(()=>{
        openUploader();
    }, [
        openUploader
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "box-border flex size-full items-start justify-center py-8 md:py-12",
        "data-testid": BOARD_COLLECTION_EMPTY_STATE,
        children: /*#__PURE__*/ _jsx("div", {
            className: "flex size-full flex-col items-start justify-start",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "relative flex w-full flex-1 flex-col items-center justify-center rounded border border-grey-5",
                children: [
                    isAboveSmallScreen ? /*#__PURE__*/ _jsx("div", {
                        className: "absolute top-[calc(50%-200px)] w-full max-w-[643px]",
                        children: /*#__PURE__*/ _jsx(Image, {
                            width: 643,
                            height: 201,
                            src: "/assets/illustrations/empty-board-collection-desktop.svg",
                            alt: EMPTY_BOARD_IMG_ALT
                        })
                    }) : /*#__PURE__*/ _jsx("div", {
                        className: "mb-4 w-full max-w-[276px] opacity-50 grayscale",
                        children: /*#__PURE__*/ _jsx(Image, {
                            width: 276,
                            height: 125,
                            src: "/assets/illustrations/empty-board-mobile.svg",
                            alt: EMPTY_BOARD_IMG_ALT
                        })
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        appearance: "filled",
                        color: "blue",
                        "data-testid": BOARD_COLLECTION_SELECT_FILES,
                        onClick: _openUploader,
                        size: "medium",
                        children: "Select files"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-4 text-14 text-grey-10",
                        children: "or drag and drop to upload"
                    })
                ]
            })
        })
    });
});
BoardCollectionEmptyState.displayName = "BoardCollectionEmptyState";
